
		letterAdjust.scale = 0.9;
		// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
		var font = {
			".": "M672-98v-312H360v312H672z",
			"'": "M360,1638h311l0-648H360L360,1638z",
			"-": "M1008,770V459H360v311H1008z",
			"0": "M354 -182v1593l228 227h573l225 -227v-1593l-225 -228h-573zM715 -49h307v1327h-307v-1327z",
			"1": "M356 -49h172v1198h-172v203l199 286h334v-1687h172v-361h-705v361z",
			"2": "M358 317l668 510v451h-307v-129h-361v262l228 227h573l225 -227v-760l-665 -512v-188h665v-361h-1026v727z",
			"3": "M354 80h361v-129h307v483h-315v361h315v483h-307v-129h-361v262l228 227h573l225 -227v-715l-82 -82l82 -82v-714l-225 -228h-573l-228 228v262z",
			"4": "M272 186v424l643 1028h373v-1091h172v-361h-172v-235h172v-361h-704v361h172v235h-656zM657 547h271v434z",
			"5": "M360 80h361v-129h307v483h-668v1204h1026v-360h-665v-483h440l225 -228v-749l-225 -228h-573l-228 228v262z",
			"6": "M354 -182v1593l228 227h573l225 -227v-262h-358v129h-307v-483h440l225 -228v-749l-225 -228h-573zM715 -49h307v483h-307v-483z",
			"7": "M336 1149v489h1026v-340l-424 -1708h-371l420 1688h-291v-129h-360z",
			"8": "M354 -182v714l82 82l-82 82v715l228 227h573l225 -227v-715l-82 -82l82 -82v-714l-225 -228h-573zM715 -49h307v483h-307v-483zM715 795h307v483h-307v-483z",
			"9": "M354 80h361v-129h307v483h-440l-228 228v749l228 227h573l225 -227v-1593l-225 -228h-573l-228 228v262zM715 795h307v483h-307v-483z",
			"A": "M289 -410l311 2048h465l311 -2048h-315l-68 443h-321l-68 -443h-315zM721 346h225l-112 739z",
			"B": "M360 -410v2048h480q39 0 61.5 -1t66.5 -6t72.5 -14t68.5 -29.5t66.5 -49.5t56.5 -75t47 -102t29.5 -136t12.5 -176q0 -78 -24.5 -152t-59.5 -123t-68.5 -87t-58.5 -54l-25 -19q10 -6 25.5 -18t56.5 -54t72 -89t56.5 -121t25.5 -152q0 -96 -12.5 -176t-29.5 -136 t-47 -102.5t-56.5 -75t-66.5 -49t-68.5 -29.5t-72.5 -14.5t-66.5 -6.5t-61.5 -1h-480zM674 -98h166q70 0 119 82t49 196.5t-49.5 196.5t-118.5 82h-166v-557zM674 770h166q70 0 119 82t49 196.5t-49.5 196.5t-118.5 82h-166v-557z",
			"C": "M344 70v1089q0 199 140.5 339t339 140t340 -140t141.5 -339v-250h-314v250q0 70 -49 118t-118.5 48t-118 -48t-48.5 -118v-1089q0 -70 48.5 -118t118 -48t118.5 48t49 118v249h314v-249q0 -199 -141.5 -339.5t-340 -140.5t-339 140.5t-140.5 339.5z",
			"D": "M360 -410v2048h480q199 0 340 -140t141 -339v-1089q0 -199 -141.5 -339.5t-339.5 -140.5h-480zM674 -96h166q70 0 119 48t49 118v1089q0 70 -49.5 119t-118.5 49h-166v-1423z",
			"E": "M360 -410v2048h803v-311h-491v-557h336v-311h-336v-557h491v-312h-803z",
			"F": "M360 -410v2048h803v-311h-491v-557h336v-311h-336v-869h-312z",
			"G": "M344 70v1089q0 199 140.5 339t339 140t340 -140t141.5 -339v-250h-314v250q0 70 -49 118t-118.5 48t-119 -48t-49.5 -118v-1089q0 -70 49.5 -118t119 -48t118.5 48t49 118v233h-168v311h482v-1024h-158l-70 187q-4 -8 -11 -20.5t-34.5 -45.5t-63.5 -56.5t-96.5 -44 t-132.5 -20.5q-190 0 -292.5 135.5t-102.5 344.5z",
			"H": "M360 -410v2048h314v-868h334v868h313v-2048h-313v869h-334v-869h-314z",
			"I": "M360 -410v2048h312v-2048h-312z",
			"J": "M293 -98h168q70 0 119 49t49 119v1568h311v-1568q0 -199 -140.5 -339.5t-338.5 -140.5h-168v312z",
			"K": "M360 -410v2048h312v-649l336 649h313l-365 -704l365 -1344h-313l-256 947l-80 -152v-795h-312z",
			"L": "M362 -410v2048h312v-1736h491v-312h-803z",
			"M": "M360 -410v2048h420l221 -1212l220 1212h419v-2048h-313v1414l-254 -1414h-145l-256 1414v-1414h-312z",
			"N": "M360 -410v2048h314l334 -1060v1060h313v-2048h-313l-334 1061v-1061h-314z",
			"O": "M344 70v1089q0 199 140.5 339t339 140t340 -140t141.5 -339v-1089q0 -199 -141.5 -339.5t-340 -140.5t-339 140.5t-140.5 339.5zM657 70q0 -70 48.5 -118t118 -48t118.5 48t49 118v1089q0 70 -49 118t-118.5 48t-118 -48t-48.5 -118v-1089z",
			"P": "M360 -410v2048h480q39 0 61.5 -1t66.5 -6t72.5 -15t68.5 -30.5t66.5 -50.5t56.5 -77t47 -105.5t29.5 -141.5t12.5 -181t-12.5 -180t-29.5 -141.5t-47 -105.5t-56.5 -75.5t-66.5 -50t-68.5 -31t-72.5 -16.5t-66.5 -6h-61.5h-168v-834h-312zM672 735h168q168 0 168 296 t-168 296h-168v-592z",
			"Q": "M344 68v1089q0 199 141.5 340t340 141t340 -141t141.5 -340v-1089q-1 -113 -50 -211q66 -53 148 -54v-311q-209 0 -350 152q-106 -57 -230 -58q-199 0 -340 141.5t-141 340.5zM657 68q0 -70 49.5 -119t119 -49t118.5 49t49 119v1089q0 70 -49 119t-118.5 49t-119 -49 t-49.5 -119v-1089z",
			"R": "M360 -410v2048h480q39 0 61.5 -1t66.5 -6t72.5 -15t68.5 -30.5t66.5 -50.5t56.5 -77t47 -105.5t29.5 -141.5t12.5 -181q0 -440 -221 -559l221 -881h-322l-211 834h-116v-834h-312zM674 735h166q168 0 168 295t-168 295h-166v-590z",
			"S": "M344 70v110h313v-110q0 -70 48.5 -118t118 -48t118.5 48t49 118q0 82 -27.5 153.5t-72.5 124.5t-103.5 108.5t-120 103.5t-118.5 110.5t-103.5 128t-74 159t-27.5 201.5q0 199 140.5 339t339 140t340 -140t141.5 -339v-110h-314v110q0 70 -49 118t-118.5 48t-118 -48 t-48.5 -118q0 -74 21.5 -136t59.5 -109.5t86 -91.5t102.5 -86t107.5 -87t102.5 -101t86.5 -123t59.5 -157t22.5 -198q0 -199 -140.5 -339.5t-340 -140.5t-340 140.5t-140.5 339.5z",
			"T": "M330 1325v313h960v-313h-323v-1735h-314v1735h-323z",
			"U": "M356 70v1568h312v-1568q0 -70 49 -118t118.5 -48t119 48t49.5 118v1568h313v-1568q0 -199 -141.5 -339.5t-340 -140.5t-339 140.5t-140.5 339.5z",
			"V": "M315 1638h314l166 -1099l168 1099h313l-313 -2048h-334z",
			"W": "M315 1638h314l166 -1179l168 1179h241l168 -1179l168 1179h311l-311 -2048h-336l-121 1024l-120 -1024h-334z",
			"X": "M338 -410l324 1024l-324 1024h313l166 -530l168 530h313l-323 -1024l323 -1024h-313l-168 531l-166 -531h-313z",
			"Y": "M297 1638h326l186 -606l186 606h326l-356 -1163v-885h-312v885z",
			"Z": "M358 -98l648 1423h-648v313h961v-313l-649 -1423h649v-312h-961v312z"
		};
		var font_size = 21,
			panel_Hor_Adjustment = -0.5,
			font_Top_Adjustment = -6,
			tracking = 1,
			small_Caps_Adjustment = {
				vertical: 0,
				horizontal: 0,
				scale_width: 0,
				scale_height: 0,
			},
			colors = {
				characters: {
					home: [
						"#FFFFFF",
					],
					away: [
						"#004E38", 
					]
				},
				numbers: {
					home: [
						"#FFFFFF",
					],
					away: [
						"#004E38", 
					]
				}
			},
			outlines = {
				characters: {
					width: 1.5 // also acts as tracking if no outlines exsist
				},
				numbers: {
					width: 3
				}
			},
			special_Character_Adjustments = {
				period: {
					vertical: 3, // this moves it up from the bottom
					horizontal: -2.5,
					scale_width: 15.5,
					scale_height: 15.5,
				},
				hyphen: {
					vertical: 0,
					horizontal: -5.5,
					scale_width: 0,
					scale_height: -12,
				},
				apostrophe: {
					vertical: -5.75,
					horizontal: -2.5,
					scale_width: 0,
					scale_height: 0,
				}
			},
			number_Adjustments = {
				top: 19,
				left: -10,
				width: 81,
				height: 61,
				middle_Space: 5,
			};